import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Swiper core styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Md5G } from "react-icons/md";

const CarSection = ({inventories,getAllInventory,companies,loading,error,page,setPage,totalItems,totalPages,limit}) => {
  const navigate = useNavigate()
  const handleNavigate = (id) => {
    localStorage.setItem("Inventory-Detail",JSON.stringify({id}))
    navigate("/InventoryDetail")
  }
  return (
    <div>
      {/* cars-section-three */}
      <section className="cars-section-four v1 layout-radius">
        {error && <div className="boxcar-container"><p style={{fontSize:"18px",color:"red"}}>{error}</p></div>}
        {loading? <div className="boxcar-container"><p style={{textAlign:"center"}}>Loading...</p></div>:<div className="boxcar-container">
          <div className="boxcar-title-three wow fadeInUp">
            <h2>New and Used Cars For Sale</h2>
          </div>
          <div className="text-box">
            <div className="text">Showing {(page - 1) * limit + 1} to {Math.min(page * limit, totalItems)} of {totalItems} vehicles</div>
            <form>
              <div className="form_boxes v3">
                <small>Sort by</small>
                <div className="drop-menu">
                  <div className="select">
                    <span>Company</span>
                    <i className="fa fa-angle-down" />
                  </div>
                  <input type="hidden" name="gender" />
                  <ul className="dropdown" style={{ display: "none" }}>
                    {companies?.map((c,index)=><li onClick={()=>getAllInventory(page,limit,{"company":c})} key={index}>{c}</li>)}
                  </ul>
                </div>
              </div>
            </form>
          </div>
          <div className="row wow fadeInUp">
           {inventories?.map((item) => (
  <div key={item?._id} className="car-block-four col-xl-3 col-lg-4 col-md-6 col-sm-6">
    <div className="inner-box">
      {/* IMAGE SECTION */}
      <div className="image-box">

        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: `.prev-${item?._id}`,
            nextEl: `.next-${item?._id}`,
          }}
          className="image"
        >
          {item?.media?.map((img) => (
            <SwiperSlide key={img?.path}>
              <a href={img?.path} data-fancybox="gallery">
                <img
                  src={img?.path}
                  alt="Car"
                  style={{ height: "250px", width: "100%", objectFit: "cover" }}
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* CUSTOM NAV BUTTONS */}
        <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className={`swiper-prevv prev-${item?._id} slick-arrow`} aria-label="Previous">
                                                              <FaChevronLeft size={18} />
                                                            </button>
                                                            <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className={`swiper-nextt next-${item?._id} slick-arrow`} aria-label="Next">
                                                              <FaChevronRight size={18} />
                                                            </button>

        {/* Bookmark Icon */}
        <a className="icon-box">
          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12">
            <path
              d="M9.39 12c-.24 0-.47-.07-.68-.2L6.12 10.15a.41.41 0 00-.24 0L3.29 11.8c-.48.31-1.15.24-1.56-.16A1.1 1.1 0 011.34 10.73V1.27C1.34.57 1.91 0 2.61 0H9.39c.7 0 1.27.57 1.27 1.27v9.46c0 .7-.57 1.27-1.27 1.27z"
              fill="black"
            />
          </svg>
        </a>
      </div>

      {/* CONTENT SECTION */}
      <div className="content-box">
        <h6 className="title">
          <a href="#">{item?.title}</a>
        </h6>

        <div className="text">
          {(item?.carDetails?.description || "").slice(0, 150)}
        </div>

        <ul>
          <li>
            <i className="flaticon-gasoline-pump" />
            {item?.carDetails?.mileage} miles
          </li>
          <li>
            <i className="flaticon-speedometer" />
            {item?.carDetails?.fuelType}
          </li>
          <li>
            <i className="flaticon-gearbox" />
            {item?.carDetails?.transmission}
          </li>
        </ul>

        <div className="btn-box">
          {item?.price?.amount && <small>$ {item?.price?.amount}</small>}

          <a
            href="#"
            className="details"
            onClick={() => handleNavigate(item?._id)}
          >
            View Details
            <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
              <path
                d="M13.61 0H5.05c-.21 0-.39.17-.39.39s.18.39.39.39h7.62L.11 13.34c-.15.15-.15.39 0 .55.08.08.18.11.28.11s.2-.03.28-.11L13.22 1.33v7.62c0 .21.17.39.39.39s.39-.18.39-.39V.39A.39.39 0 0013.61 0z"
                fill="#405FF2"
              />
            </svg>
          </a>
        </div>

      </div>
    </div>
  </div>
))}

          </div>
          <div className="pagination-sec">
  <nav aria-label="Page navigation example">
    <ul className="pagination">

      {/* Previous Button */}
      <li className={`page-item ${page <= 1 ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => page > 1 && setPage(page - 1)}
        >
          <span aria-hidden="true">
            <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
              <path
                d="M2.57983 5.99989C2.57983 5.7849 2.66192 5.56987 2.82573 5.4059L7.98559 0.24617C8.31382 -0.0820565 8.84598 -0.0820565 9.17408 0.24617C9.50217 0.574263 9.50217 1.10632 9.17408 1.43457L4.60841 5.99989L9.17376 10.5654C9.50185 10.8935 9.50185 11.4256 9.17376 11.7537C8.84566 12.0821 8.31366 12.0821 7.98544 11.7537L2.82555 6.59404C2.66176 6.42999 2.57983 6.21495 2.57983 5.99989Z"
                fill="#050B20"
              />
            </svg>
          </span>
        </button>
      </li>

      {/* Page Numbers */}
      {[...Array(totalPages)].map((_, idx) => {
        const pageIndex = idx + 1;
        return (
          <li
            key={pageIndex}
            className={`page-item ${pageIndex === page ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => setPage(pageIndex)}
            >
              {pageIndex}
            </button>
          </li>
        );
      })}

      {/* Next Button */}
      <li className={`page-item ${page >= totalPages ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => page < totalPages && setPage(page + 1)}
        >
          <span aria-hidden="true">
            <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
              <path
                d="M9.42017 6.00011C9.42017 6.2151 9.33808 6.43013 9.17427 6.5941L4.01441 11.7538C3.68618 12.0821 3.15402 12.0821 2.82592 11.7538C2.49783 11.4257 2.49783 10.8937 2.82592 10.5654L7.39159 6.00011L2.82624 1.43461C2.49815 1.10652 2.49815 0.574382 2.82624 0.246315C3.15434 -0.0820709 3.68634 -0.0820709 4.01457 0.246315L9.17446 5.40596C9.33824 5.57001 9.42017 5.78505 9.42017 6.00011Z"
                fill="#050B20"
              />
            </svg>
          </span>
        </button>
      </li>
    </ul>

    <div className="text">
      Showing results {(page - 1) * limit + 1} –
      {Math.min(page * limit, totalItems)} of {totalItems}
    </div>
  </nav>
</div>

        </div>}
      </section>
    </div>
  );
};

export default CarSection;
